import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.define-property";
import { __decorate, __extends } from "tslib";
import { px2 } from '@/lib/utils';
import { Component, Vue, Prop } from 'vue-property-decorator';

var Daisy =
/** @class */
function (_super) {
  __extends(Daisy, _super);

  function Daisy() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Object.defineProperty(Daisy.prototype, "width", {
    get: function get() {
      return px2.rem6(this.size) + 'rem';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Daisy.prototype, "indicatorWidth", {
    get: function get() {
      return px2.rem6(this.indicatorSize) + 'rem';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Daisy.prototype, "indicatorX", {
    get: function get() {
      return px2.rem6(this.indicatorOffset) + 'rem';
    },
    enumerable: false,
    configurable: true
  });

  __decorate([Prop({
    type: Number,
    "default": 48
  })], Daisy.prototype, "size", void 0);

  __decorate([Prop({
    type: Number,
    "default": 12
  })], Daisy.prototype, "indicatorSize", void 0);

  __decorate([Prop({
    type: Number,
    "default": 10
  })], Daisy.prototype, "indicatorOffset", void 0);

  Daisy = __decorate([Component({
    name: 'DaisySpinner'
  })], Daisy);
  return Daisy;
}(Vue);

export default Daisy;